<template>
  <div
    type="button"
    :class="[classes, pointClass]"
    class="select-rewrite"
    @click="passMethod('click')"
  >
    <select
      class="select"
      :class="selectClass"
      style="
        float: left;
        width: 100%;
        height: 100%;
        color: inherit;
        outline: inherit;
        font-size: inherit;
        position: relative;
        z-index: 1;
      "
      :pointValue="selectVal"
      v-model="selectVal"
      ref="selectEle"
      @change="onSelect($event.target.value)"
    >
      <slot name="option"></slot>
    </select>
    <em :style="afterIconStyles" class="select-icon icon">
      <slot name="ico" class="select-icon icon"></slot>
    </em>
  </div>
</template>

<script>
import themeMixins from '@mixins/officialTopupNew/themeMixins';
import iconSetting from '@mixins/officialTopupNew/iconSetting';
import { isIE } from '@utiles/officialStore/device';
export default {
  mixins: [themeMixins, iconSetting],
  props: ['value', 'icon', 'active', 'rightSpan', 'selectClass', 'pointValue'],
  data() {
    return {
      selectVal: this.value,
      isIE: isIE()
    };
  },
  computed: {
    showIcon() {
      return undefined != this.iconTheme && this.iconTheme;
    },
    showDefault() {
      return undefined != this.iconTheme && this.iconTheme == 'default';
    },
    iconTypeAssigned() {
      return this.icon !== undefined;
    }
  },
  watch: {
    value(newVal) {
      this.selectVal = newVal;
    }
  },
  methods: {
    onSelect(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      const selectEle = this.$refs.selectEle;
      selectEle && typeof selectEle.blur === 'function' && selectEle.blur();
    }
  },
  mounted() {
    let _self = this;
    // 这里和上面的blur，主要是为了避免在选中select的时候切换屏幕再回来时会自动触发聚焦上报。
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState == 'hidden') {
        try {
          const selectElem = _self.$refs.selectEle;
          selectElem &&
            typeof selectElem.blur === 'function' &&
            selectElem.blur();
        } catch (error) {}
      }
    });
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';
.selectIcon {
  position: absolute;
  width: 20.5px;
  display: block;
  &.selectIcon-defalt {
    color: inherit;
    right: 24px;
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
  }
}
.select-rewrite {
  color: #333;
  padding: 0 !important;
  cursor: pointer;
  .select {
    padding: 0 20px;
  }
}
.select {
  border: 0;
  -webkit-appearance: none;
  background: transparent;
}

.select-icon {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 48px;
}
select:invalid {
  color: red;
}
</style>
